import { Component } from '@angular/core';

import { Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';

import { ConnectionAlertService } from './connection-alert.service';

@Component({
  selector: 'tr-connection-alert',
  templateUrl: './connection-alert.component.html',
  styleUrls: ['./connection-alert.component.scss'],
  standalone: false,
})
export class ConnectionAlertComponent {
  readonly visible$: Observable<boolean>;
  readonly isNative = Capacitor.isNativePlatform();

  constructor(service: ConnectionAlertService) {
    this.visible$ = service.visible$;
  }

  reload(): void {
    window.location.reload();
  }
}
